import { css } from '@emotion/react';

export const svg = {
  fill: {
    currentColor: css`
      fill: currentColor;
    `,
  },
  stroke: {
    currentColor: css`
      stroke: currentColor;
    `,
    width: {
      s0: css`
        stroke-width: 0;
      `,
      s1: css`
        stroke-width: 1;
      `,
      s2: css`
        stroke-width: 2;
      `,
    },
  },
};
